import styled from "styled-components";

export const Container = styled.div `
    header {
        margin-bottom: 50px;
    }

    header h4 {
        font-size: .9rem;
        font-weight: 600;
        margin-top: -10px;
        color: #ccc;
    }

    form section {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
    }

    .section-user-delete {
        position: relative;
    }

    .section-new-profile {
        position: relative;
    }

    .section-image-color {
        position: relative;
        margin-bottom: 0;
    }

    .section-image-color button {
        position: absolute;
        bottom: -5px;
        left: -5px;
        width: 30px;
        height: 30px;
        border-radius: 50%;
        color: #fff;
        font-size: 1rem;
        margin-right: 10px;
        background: #fff;
        color: #181818;
        border: none;
        cursor: pointer;
        transition: all .3s ease;
    }

    .section-image-color button:hover {
        background: #ccc;
    }
    
    form img {
        width: 120px;
        background: #303030;
        border-radius: 5px;
        margin-right: 10px;
    }

    .div-input-new-profile {
        display: flex;
        flex-direction: column;
    }

    .div-input-new-profile span {
        margin-top: 5px;
        color: #ddd;
        font-weight: 600;
    }

    form input {
        height: 40px;
        margin-bottom: 5px;
        border-radius: 5px;
        color: #fff;
        padding: 5px;
        background: #505050;
        width: 100vw;
        max-width: 250px;
        border: 1px solid #808080;
    }

    form input::placeholder {
        color: #ccc;
    }

    .section-bts-add-profile button {
        margin-right: 10px;
        border-radius: 5px;
        padding: 10px 25px;
        font-size: 1rem;
        border: none;
        font-weight: 600;
        border: 2px solid transparent;
        cursor: pointer;
        transition: all .3s ease;
    }

    .section-bts-add-profile button:hover {
        opacity: .7;
    }

    .section-bts-add-profile button:nth-child(2){
        background: unset;
        color: #fff;
        border: 2px solid #ccc;
        margin-right: 0;
    }

    
    @media (max-width: 400px) {
        .section-new-profile {
            position: relative;
            display: flex;
            flex-direction: column;
        }

        .div-input-new-profile {
            align-items: center;
        }

        header {
            text-align: center;
        }

        header h4 {
            font-size: .75rem;
        }

        .section-image-color {
            margin-bottom: 20px;
        }

        form img {
            margin-right: 0;
        }

        form input {
            height: 50px;
            border-radius: 5px;
            color: #fff;
            padding: 5px;
            background: #505050;
            width: 100vw;
            max-width: 200px;
            border: 1px solid #808080;
        }

        .section-bts-delete-profile {
            flex-direction: column;
        }

        .section-bts-delete-profile button {
            margin: 0 0 5px 0;
            border-radius: 5px;
            padding: 10px 25px;
            width: 100%;
            font-size: 1rem;
        }
    }

    @media (max-width: 300px) {
        
        .section-bts-add-profile {
            display: flex;
            flex-direction: column;
        }
        
        .section-bts-add-profile button {
            margin: 0 0 5px 0;
            width: 100%;
        }
    }
`
